module.exports = __webpack_public_path__ + "media/gun_2.cabb846c.webm";